import css from "classnames";
import React from "react";
import { selectValues } from "../query";
import { Payload, Record } from "../types";
import styles from "./preview-value.module.css";

interface Props {
  column: string;
  state: Payload<Record>;
}

// PreviewValue displays the first non-empty value for the given column and
// allows the user to cycle through the values by clicking on it.
const PreviewValue: React.FC<Props> = props => {
  if (!props.state.file === null) return null;

  const nonUniqValues = selectValues(props.state, props.column)
    .map(val => val.trim())
    .filter(Boolean);

  const values = [...new Set(nonUniqValues)];

  const [offset, setoffset] = React.useState(0);

  if (values.length === 0) return null;

  const onCyclePreview = () => {
    if (offset < values.length - 1) {
      setoffset(offset + 1);
      return;
    }

    setoffset(0);
  };

  const content = values[offset];
  return (
    <div
      onClick={onCyclePreview}
      title={content}
      className={css({
        [styles.value]: true,
        [styles.only]: values.length === 1,
      })}
    >
      {content}
    </div>
  );
};

export default PreviewValue;
